// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Eq-z","slideIn":"Fq-z"};